class FaqList extends HTMLElement {
  constructor() {
    super()
    this.selectors = {
      faqDropdowns: ".faqs dl dt",
    }
  }

  connectedCallback() {
    const faqDropdowns = this.querySelectorAll(this.selectors.faqDropdowns);

    faqDropdowns.forEach(faqDropdown => {
      faqDropdown.addEventListener('click', function handleClick(event) {
        event.target.classList.toggle("dt-open");
        event.target.nextElementSibling.classList.toggle("dshow");
      });
    });
  }
}

if (!customElements.get('faq-list')) customElements.define('faq-list', FaqList)
